import React, { useEffect, useState } from 'react';

import '../../Assets/Pages/activeDoctor.css';

// WEBSOCKET DISABLED - Using HTTP polling only
// import { socket } from '../../Constants';
import { fetchApi } from '../../Network/NetworkService';

/**
 * Format relative time in French
 */
const getRelativeTime = (date) => {
    if (!date) return '-';
    const now = new Date();
    const past = new Date(date);
    const diffMs = now - past;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'À l\'instant';
    if (diffMins < 60) return `Il y a ${diffMins} min`;
    if (diffHours < 24) return `Il y a ${diffHours}h`;
    if (diffDays < 7) return `Il y a ${diffDays}j`;
    return past.toLocaleDateString('fr-FR');
};

const DoctorActive = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [activeCount, setActiveCount] = useState(0);

    /**
     * Fetch active doctors from api.feeli.io via proxy
     * Step 1: Get active doctor IDs from api.feeli.io (via backend proxy)
     * Step 2: Get full doctor details from local API
     */
    const fetchActiveDoctors = async () => {
        setLoading(true);
        setErrorMessage('');

        try {
            // Step 1: Get active doctor IDs from api.feeli.io via proxy
            const proxyResponse = await fetchApi('/active-doctors-proxy', {
                method: 'GET'
            });

            if (!proxyResponse.success) {
                throw new Error(proxyResponse.message || 'Failed to fetch active doctors');
            }

            setActiveCount(proxyResponse.count);

            // Step 2: If we have active doctor IDs, fetch their details from local API
            if (proxyResponse.doctorIds && proxyResponse.doctorIds.length > 0) {
                const detailsResponse = await fetchApi('/doctors/active', {
                    method: 'POST',
                    body: JSON.stringify({ ids: proxyResponse.doctorIds })
                });

                setData(detailsResponse.doctors || []);
            } else {
                setData([]);
            }

            setLoading(false);
        } catch (err) {
            setLoading(false);
            setErrorMessage('Impossible de récupérer la liste des médecins actifs: ' + err.message);
            console.error('Fetch error:', err);
        }
    };

    useEffect(() => {
        // Initial fetch
        fetchActiveDoctors();

        // Poll every 30 seconds for updates
        const pollInterval = setInterval(() => {
            fetchActiveDoctors();
        }, 30000); // 30 seconds

        // Cleanup interval on unmount
        return () => {
            clearInterval(pollInterval);
        };
    }, []);

    // WEBSOCKET CODE COMMENTED OUT - Not working with CloudFront/Nginx
    // useEffect(() => {
    //     let connectionTimeout;
    //     const handleConnect = () => { ... };
    //     const handleDisconnect = () => { ... };
    //     const handleConnectError = (error) => { ... };
    //     const handleReconnect = () => { ... };
    //     const handleActiveDoctors = (ids) => { ... };
    //     
    //     socket.on('connect', handleConnect);
    //     socket.on('disconnect', handleDisconnect);
    //     socket.on('connect_error', handleConnectError);
    //     socket.on('reconnect', handleReconnect);
    //     socket.on('activeDoctors', handleActiveDoctors);
    //     
    //     return () => { ... };
    // }, []);

    /**
     * Manual refresh button handler
     */
    const handleRefresh = () => {
        fetchActiveDoctors();
    };

    return (
        <div className="doctor-active">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p>Les docteurs disponibles {activeCount > 0 && <span style={{ color: '#4CAF50', fontWeight: 'bold' }}>({activeCount} en ligne)</span>}</p>
                    <button onClick={handleRefresh} type="button" className="zmdi zmdi-refresh-alt"></button>
                </div>
                {/* Auto-refresh every 30 seconds */}
                <div style={{ fontSize: '12px', color: 'gray' }}>
                    Actualisation automatique (30s) - Source: api.feeli.io
                </div>
            </div>

            {errorMessage && (
                <div style={{ color: 'orange', fontSize: '12px', marginTop: '10px', padding: '5px', backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px' }}>
                    {errorMessage}
                </div>
            )}

            <div className="table-responsive">
                <table className="table table-hover mb-0">
                    <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Statut</th>
                            <th>Consultations du jour</th>
                            <th>Dernière activité</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="4">Chargement...</td>
                            </tr>
                        ) : data.length === 0 ? (
                            <tr>
                                <td colSpan="4">Aucun médecin actif pour le moment</td>
                            </tr>
                        ) : (
                            data.map((v) => (
                                <tr key={v._id}>
                                    <td>
                                        <span onClick={() => props.history.push(`/doctors/detail/${v._id}`)}>
                                            {`${v.FName} ${v.LName}`}
                                        </span>
                                    </td>
                                    <td>
                                        {/* Status based on today's activity */}
                                        {v.todayConsultations > 0 ? (
                                            <span style={{ color: 'green' }}>
                                                <i className="zmdi zmdi-circle"></i> Actif
                                            </span>
                                        ) : (
                                            <span style={{ color: 'orange' }}>
                                                <i className="zmdi zmdi-circle-o"></i> En attente
                                            </span>
                                        )}
                                    </td>
                                    <td>
                                        {v.todayConsultations > 0 ? (
                                            <span style={{
                                                backgroundColor: '#17a2b8',
                                                color: 'white',
                                                padding: '4px 12px',
                                                borderRadius: '12px',
                                                fontWeight: 'bold'
                                            }}>
                                                {v.todayConsultations} consultation{v.todayConsultations > 1 ? 's' : ''}
                                            </span>
                                        ) : (
                                            <span style={{ color: '#999' }}>0</span>
                                        )}
                                    </td>
                                    <td>
                                        <span title={v.lastActivityDate ? new Date(v.lastActivityDate).toLocaleString('fr-FR') : ''}>
                                            {getRelativeTime(v.lastActivityDate)}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DoctorActive;
